export default __webpack_public_path__ + "static/media/Calendar of Event.de2a635c.pdf";